module.exports = __webpack_public_path__ + "img/1.9bc5af00.jpg";